import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Direction académique",
  title: "Direction de Suivi et Encadrement du Personnel Académique et Scientifique",
  banner_image: "/media/research-lab.jpg",
  intro:
    "La Direction de Suivi et Encadrement du Personnel Académique et Scientifique assure la gestion de carrière, l'accompagnement pédagogique et scientifique, ainsi que le développement professionnel des enseignants-chercheurs de l'UNISIC.",
  missions:
    "• Suivi de carrière du personnel académique et scientifique\n• Encadrement pédagogique et méthodologique\n• Évaluation périodique et développement des compétences\n• Coordination avec les Facultés et Directions académiques\n• Élaboration des rapports d'activité",
};

export default function DirectionSuiviEncadrement() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/direction.suivi_encadrement").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);

  return (
    <div data-testid="direction-suivi-page">
      <section className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-4xl">
            {content.title}
          </h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-dark">Présentation</div>
            <span className="divider-gold mt-3" />
            <p className="mt-6 text-lg text-slate-700 leading-relaxed whitespace-pre-line">
              {content.intro}
            </p>
          </div>
          <aside className="paper-card p-6 h-fit">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-unisic-blue text-white mb-3">
              <Users className="w-5 h-5" />
            </div>
            <div className="eyebrow eyebrow-dark">Missions</div>
            <span className="divider-gold mt-2" />
            <p className="mt-4 text-sm text-slate-700 leading-relaxed whitespace-pre-line">
              {content.missions}
            </p>
          </aside>
        </div>
      </section>
    </div>
  );
}
